export async function locationDownloadBarcodeUseCase(ids, locationRepository) {
    const result = await locationRepository.download_barcode(ids);

    // const entity = new locationRepository.model(result.data.success.arguments);
    
    // if (!entity.isValid()) {
    //     throw new Error("tote inválido");
    // }

    return result;
}